/* eslint-disable @redbubble/design-system/no-style-overrides */

import React from "react";
import PropTypes from "prop-types";
import posed from "react-pose";
import sanitize from "sanitize-html";
import Collapsible from "@redbubble/design-system/react/Collapsible";
import List, { ListItem } from "@redbubble/design-system/react/List";
import Box from "@redbubble/design-system/react/Box";
import Text from "@redbubble/design-system/react/Text";
import ChevronDownBigIcon from "@redbubble/design-system/react/Icons/ChevronDownBig";
import styles from "./styles.scss";

const CollapsibleArrow = posed.div({
  closed: {
    transform: "rotate(0deg)",
  },
  open: {
    transform: "rotate(180deg)",
  },
});

const questionTrigger =
  (faqItem) =>
  // props defined by the design system component
  // eslint-disable-next-line react/prop-types
  ({ collapsed, toggleCollapsible }) => {
    return (
      <ListItem
        role="button"
        onClick={() => toggleCollapsible()}
        className={styles.faqListItem}
      >
        <Text
          type="display6"
          display="block"
          dangerouslySetInnerHTML={{ __html: sanitize(faqItem.question) }}
        />
        <CollapsibleArrow pose={collapsed ? "closed" : "open"}>
          <ChevronDownBigIcon />
        </CollapsibleArrow>
      </ListItem>
    );
  };

const ProductDescriptionFAQ = ({ title, items }) => (
  <Box
    className={styles.container}
    padding="s"
    textAlign="left"
    display="flex"
    justifyContent="space-between"
    flexDirection="column"
  >
    <Box marginBottom="s" marginTop="s">
      <Text
        style={{ textTransform: "capitalize" }}
        type="display5"
        element="h3"
      >
        {title}
      </Text>
    </Box>
    <Box marginBottom="s">
      <List divided relaxed>
        {items.map((item) => (
          <Collapsible
            key={sanitize(item.question)}
            trigger={questionTrigger(item)}
          >
            <Box padding="m">
              <Text
                type="body2"
                display="block"
                dangerouslySetInnerHTML={{ __html: sanitize(item.answer) }}
              />
            </Box>
          </Collapsible>
        ))}
      </List>
    </Box>
  </Box>
);

const itemProps = PropTypes.shape({
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
});

ProductDescriptionFAQ.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(itemProps).isRequired,
};

export const ProductDescriptionFAQType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(itemProps).isRequired,
});

export default ProductDescriptionFAQ;
